export interface StateActionTypes {
  type: StateActions;
  payload?: any;
}

export enum StateActions {
  CREATE_STATE = "CREATE_STATE",
  GET_STATE_LIST = "GET_STATE_LIST",
  SET_STATE_LIST = "SET_STATE_LIST",
  SET_STATE_LIST_PAGE_COUNT = "SET_STATE_LIST_PAGE_COUNT",
  DELETE_STATE = "DELETE_STATE",
  GET_STATE_DATA_BY_ID = "GET_STATE_DATA_BY_ID",
  SET_STATE_DATA_BY_ID = "SET_STATE_DATA_BY_ID",
  EDIT_STATE_DATA_BY_ID = "EDIT_STATE_DATA_BY_ID",
}
